import request from "../config/axios-config";

export function getAllContracts(year) {
  return request({
    method: "get",
    url: "/contracts/" + year
  });
}
